import React, { FC } from 'react';
import { TeamOutlined } from '@ant-design/icons';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getAvatarStyle } from '../../utils/ImageUtils';

// Color-coded group icon + name.
//
// The color is derived from the group name rather than stored: `BuyerUserGroup` has no color
// column, and the write path ignores any color the client sends. `getAvatarStyle` hashes the
// name to a stable hue and hands back a matching readable foreground, so each group keeps a
// distinct, consistent swatch across sessions. Consequence to be aware of: renaming a group
// changes its color. If admin-chosen colors are wanted, the backend needs a `color` field.
const UserGroupRowDisplay: FC<any> = ({ record }): React.ReactElement => {
	const name = nullSafeGetOrElse('name', record, '');
	const avatarStyle = getAvatarStyle(name);
	return (
		<div className="flex items-center gap-3">
			<span
				className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded"
				style={{ backgroundColor: avatarStyle.backgroundColor }}
			>
				<TeamOutlined style={{ color: avatarStyle.color }} />
			</span>
			<span className="bodyregular text-character-primary">{name || '--'}</span>
		</div>
	);
};

export default UserGroupRowDisplay;
